/* KOJO custom layer — M7 collection & search (v2).
   <kj-collection>: AJAX native filters + sort via the Section Rendering API (history aware), client-side THEME filters
   (kj_<group>=<token> URL params; OR within a group, AND across groups) on top of the native ones, toolbar quick chips,
   density toggle (persisted, desktop/tablet), "ver más" / infinite loading, sticky toolbar that follows the floating
   header (CSS var --kj-header-visible published by kojo-header.js), chip row overflow hints.
   Theme-filter data lives on every grid item (snippets/kojo-collection-facts.liquid: data-kj-f-<group>, data-kj-f-l);
   the drawer rows are [data-kj-tf-group] (never [data-kj-facet], so native re-renders never replace them).
   Event: document 'kj:collection:render' {kind: 'init'|'update'|'more'|'theme'|'history', el, active, visible}.
   Uses window.KJ (kojo-core.js) when present. */
(function () {
  'use strict';
  if (customElements.get('kj-collection')) return;

  var KEY = 'kj-coll-density';
  var RING_KEY = 'kj-ring-size';
  var TF = 'kj_';
  var TEE = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '3xl', 'xxxl', '4xl', '5xl'];
  var X_ICON = '<svg class="kj-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var uid = 0;

  function store(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) { /* storage blocked */ }
    return null;
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function debounce(fn, ms) {
    var t;
    return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); };
  }
  function clean(href) {
    try {
      var u = new URL(href, window.location.href);
      u.searchParams.delete('section_id');
      u.searchParams.delete('sections');
      var q = u.searchParams.toString();
      return u.pathname + (q ? '?' + q : '') + u.hash;
    } catch (e) { return href; }
  }
  function withSection(href, sid) {
    var u = new URL(href, window.location.href);
    u.searchParams.set('section_id', sid);
    return u.pathname + '?' + u.searchParams.toString();
  }
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function esc(v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/["\\]/g, '\\$&'); }
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function words(v) { return String(v || '').split(/\s+/).filter(Boolean); }
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isNaN(n) ? null : n; }
  function fill(tpl, n) { return String(tpl || '').replace('[count]', String(n)); }

  /* URL without theme params (and without section params): the state the server renders */
  function stripTheme(href) {
    try {
      var u = new URL(href, window.location.href), drop = [];
      u.searchParams.forEach(function (v, k) { if (k.indexOf(TF) === 0) drop.push(k); });
      drop.forEach(function (k) { u.searchParams.delete(k); });
      u.searchParams.delete('section_id');
      u.searchParams.delete('sections');
      var q = u.searchParams.toString();
      return u.pathname + (q ? '?' + q : '');
    } catch (e) { return href; }
  }
  /* comparable server state: no theme params, params sorted */
  function canon(href) {
    try {
      var u = new URL(stripTheme(href), window.location.href);
      if (u.searchParams.sort) u.searchParams.sort();
      var q = u.searchParams.toString();
      return u.pathname + (q ? '?' + q : '');
    } catch (e) { return href; }
  }
  function themePairs(href) {
    var out = [];
    try {
      new URL(href, window.location.href).searchParams.forEach(function (v, k) {
        if (k.indexOf(TF) === 0 && v) out.push([k, v]);
      });
    } catch (e) { /* ignore */ }
    return out;
  }
  /* server links (url_to_remove / clear_url) drop kj_*: carry the current theme state over */
  function withTheme(href, from) {
    try {
      var u = new URL(href, window.location.href), drop = [];
      u.searchParams.forEach(function (v, k) { if (k.indexOf(TF) === 0) drop.push(k); });
      drop.forEach(function (k) { u.searchParams.delete(k); });
      themePairs(from).forEach(function (p) { u.searchParams.append(p[0], p[1]); });
      var q = u.searchParams.toString();
      return u.pathname + (q ? '?' + q : '') + u.hash;
    } catch (e) { return href; }
  }
  function cmpFor(key) {
    if (key === 'talla') {
      return function (a, b) { return ((num(a.t) || 0) - (num(b.t) || 0)) || a.l.localeCompare(b.l); };
    }
    if (key === 'tallac') {
      return function (a, b) {
        var ia = TEE.indexOf(a.t), ib = TEE.indexOf(b.t);
        if (ia < 0) ia = 99;
        if (ib < 0) ib = 99;
        return (ia - ib) || a.l.localeCompare(b.l);
      };
    }
    return function (a, b) { return a.l.localeCompare(b.l, 'es', { sensitivity: 'base' }); };
  }
  /* item passes every active group except `skip` (OR inside a group, AND across groups) */
  function matches(d, st, keys, skip) {
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i], want = st[k];
      if (k === skip || !want || !want.length) continue;
      var have = d[k] || [], ok = false;
      for (var j = 0; j < want.length; j++) {
        if (have.indexOf(want[j]) > -1) { ok = true; break; }
      }
      if (!ok) return false;
    }
    return true;
  }

  class KJCollection extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.sid = this.dataset.sectionId;
      this.cache = {};
      this.gen = 0;
      this.loading = null;
      this._resizers = [];
      this.bar = this.querySelector('[data-kj-coll-bar]');
      this.sortSelect = this.querySelector('[data-kj-sort-select]');
      this.drawer = this.drawer || this.querySelector('[data-kj-facets]');
      if (this.drawer && this.drawer.parentNode !== document.body) document.body.appendChild(this.drawer);
      this.form = this.drawer ? this.drawer.querySelector('[data-kj-facets-form]') : null;

      this._onClick = this.onClick.bind(this);
      this.addEventListener('click', this._onClick);
      if (this.drawer) this.drawer.addEventListener('click', this._onClick);

      if (this.form) {
        var applySoon = debounce(function () { self.apply(null, true); }, 400);
        var applyTyped = debounce(function () { self.apply(null, true); }, 750);
        this.form.addEventListener('change', function (e) {
          var t = e.target;
          if (t.matches('[data-kj-tf]')) { self.onThemeInput(t); return; }
          self.lastGroup = t.closest('[data-kj-facet]');
          if (t.matches('[data-kj-price]')) { self.syncBuckets(self.lastGroup); applyTyped(); } else applySoon();
        });
        this.form.addEventListener('input', function (e) {
          if (!e.target.matches('[data-kj-price]')) return;
          self.lastGroup = e.target.closest('[data-kj-facet]');
          self.syncBuckets(self.lastGroup);
          applyTyped();
        });
        this.form.addEventListener('submit', function (e) { e.preventDefault(); self.apply(null, true); });
      }
      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', function () {
          var v = self.sortSelect.value;
          if (self.form) {
            var r = self.form.querySelector('input[name="sort_by"][value="' + esc(v) + '"]');
            if (r) r.checked = true;
          }
          self.syncSortFace();
          self.apply(v);
        });
      }

      this._onPop = function (e) {
        if (e.state && e.state.kjColl !== self.sid) return;
        if (!e.state) {
          // fragment entries (skip link, «Ver las piezas ↓») carry no state: ours when they are on this listing's path
          var own = null;
          try { own = new URL(self.dataset.url || window.location.pathname, window.location.href).pathname; } catch (err) { /* ignore */ }
          if (!own || own !== window.location.pathname) return;
        }
        // Back/Forward to one of our entries: a render still in flight belongs to the entry just left and must not
        // push / paint over this one (a null state can also be a fresh fragment click, which must not cancel it)
        if (e.state && self.ctrl) { self.ctrl.abort(); self.ctrl = null; self._pending = null; self.busy(false); }
        // only theme params changed: no fetch, just re-apply; otherwise re-render the server state
        if (canon(window.location.href) === self._srvUrl) self.applyTheme(window.location.href, 'history');
        else self.render(window.location.href, false);
      };
      window.addEventListener('popstate', this._onPop);
      try {
        var st = history.state && typeof history.state === 'object' ? history.state : {};
        if (st.kjColl !== this.sid) history.replaceState(Object.assign({}, st, { kjColl: this.sid }), '');
      } catch (e) { /* ignore */ }

      this._onDrawerClose = function (e) {
        if (!self.drawer || !e.detail || e.detail.name !== self.drawer.dataset.name) return;
        if (self.dirty) { self.dirty = false; self.scrollToResults(); }
      };
      document.addEventListener('kj:drawer:close', this._onDrawerClose);

      this.setDensity(this.getAttribute('data-density') === 'lo' ? 'lo' : 'hi', false);
      var af = this.querySelector('[data-kj-search-autofocus]');
      if (af && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        try { af.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
      this.initDesc();
      this.initChips();
      this.syncSortFace();
      this.initSticky();
      this.fixLinks(this);
      this.bindMore();
      this.initTheme();
    }

    disconnectedCallback() {
      this._ready = false;
      window.removeEventListener('popstate', this._onPop);
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      (this._resizers || []).forEach(function (fn) { window.removeEventListener('resize', fn); });
      this._resizers = [];
      document.removeEventListener('kj:drawer:close', this._onDrawerClose);
      if (this.io) this.io.disconnect();
      if (this.drawer && !this.isConnected) {
        if (this.drawer.close && this.drawer.classList.contains('is-open')) this.drawer.close();
        if (this.drawer.parentNode) this.drawer.parentNode.removeChild(this.drawer);
        this.drawer = null;
      }
    }

    /* ---------- events ---------- */
    onClick(e) {
      var mod = e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0;

      // theme filters: pills, «Borrar todo» (theme only), «Quitar «x»», quick chips
      var rm = e.target.closest('[data-kj-tf-remove]');
      if (rm) {
        if (mod) return;
        e.preventDefault();
        var pair = rm.getAttribute('data-kj-tf-remove');
        var cut = pair.indexOf(':');
        var kb = e.detail === 0;
        this.setTheme(pair.slice(0, cut), pair.slice(cut + 1), false);
        if (kb) this.focusAfterPill();
        return;
      }
      var tc = e.target.closest('[data-kj-tf-clear]');
      if (tc) {
        if (mod) return;
        e.preventDefault();
        this.clearTheme();
        if (e.detail === 0) this.focusAfterPill();
        return;
      }
      var ub = e.target.closest('[data-kj-tf-undo]');
      if (ub) {
        e.preventDefault();
        var kbu = e.detail === 0;
        if (this._tfUndo) this.setTheme(this._tfUndo.key, this._tfUndo.token, false);
        if (kbu) this.focusAfterUndo(ub);
        return;
      }
      var qc = e.target.closest('[data-kj-quick-chip]');
      if (qc) {
        e.preventDefault();
        if (qc.disabled) return;
        this.setTheme(qc.getAttribute('data-kj-tf-key'), qc.getAttribute('data-kj-tf-token'), qc.getAttribute('aria-pressed') !== 'true');
        return;
      }
      var pb = e.target.closest('[data-kj-price-bucket]');
      if (pb) {
        e.preventDefault();
        this.applyBucket(pb);
        return;
      }

      var link = e.target.closest('[data-kj-facet-link]');
      if (link && link.href) {
        if (mod) return;
        e.preventDefault();
        var href = clean(link.href);
        // «Borrar todo» clears native AND theme filters; every other server link keeps the theme state
        if (!link.matches('[data-kj-clear-all], .kj-coll__clear, [data-kj-facets-clear]')) href = withTheme(href, this._tfUrl || window.location.href);
        this.render(href, true);
        return;
      }
      var more = e.target.closest('[data-kj-load-more]');
      if (more && this.contains(more)) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        this.loadMore(more, e.detail === 0);
        return;
      }
      var dens = e.target.closest('[data-kj-density]');
      if (dens && this.contains(dens)) {
        e.preventDefault();
        this.setDensity(dens.getAttribute('data-kj-density'), true);
        return;
      }
      var dm = e.target.closest('[data-kj-desc-more]');
      if (dm && this.contains(dm)) {
        var wrap = dm.closest('[data-kj-coll-desc]');
        var open = !wrap.classList.contains('is-open');
        wrap.classList.toggle('is-open', open);
        dm.setAttribute('aria-expanded', String(open));
        dm.hidden = open;
      }
    }

    /* ---------- filters / sort ---------- */
    buildUrl(sort) {
      var params;
      if (this.form) {
        params = new URLSearchParams();
        new FormData(this.form).forEach(function (v, k) { if (typeof v === 'string' && v.trim() !== '') params.append(k, v.trim()); });
      } else {
        params = new URLSearchParams(window.location.search);
      }
      params.delete('page');
      params.delete('section_id');
      if (sort) params.set('sort_by', sort);
      // the collection's own default sort adds nothing: keep one canonical URL per listing
      var def = this.dataset.defaultSort;
      if (def && params.get('sort_by') === def) params.delete('sort_by');
      var q = params.toString();
      return (this.dataset.url || window.location.pathname) + (q ? '?' + q : '');
    }

    apply(sort, fromForm) {
      var url = this.buildUrl(sort);
      if (canon(url) === this._srvUrl) {
        // a server render is in flight (pill / «Borrar todo» / history) and the form still holds the old native
        // state: re-issue that render with the new theme params instead of letting it overwrite them on arrival
        if (this._pending) { this.render(withTheme(this._pending, url), true, !!fromForm); return; }
        // only theme params changed (or nothing): no fetch
        if (url !== clean(window.location.href)) {
          try { history.pushState({ kjColl: this.sid }, '', url); } catch (e) { /* ignore */ }
        }
        this.applyTheme(url, 'theme');
        return;
      }
      this.render(url, true, !!fromForm);
    }

    render(url, push, fromForm) {
      var self = this;
      this.keepGroups = !!fromForm;
      // theme params never change the server HTML: fetch (and cache) without them
      var key = withSection(stripTheme(url), this.sid);
      if (this.ctrl) this.ctrl.abort();
      var ctrl = this.ctrl = 'AbortController' in window ? new AbortController() : null;
      this._pending = url;
      this.busy(true);
      var job = this.cache[key]
        ? Promise.resolve(this.cache[key])
        : fetch(key, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (html) { self.cache[key] = html; return html; });
      return job.then(function (html) {
        if (ctrl && ctrl.signal.aborted) return;
        // push BEFORE updating so the theme filters (applied in afterRender) and listeners see the target URL
        if (push) {
          try { history.pushState({ kjColl: self.sid }, '', url); } catch (e) { /* ignore */ }
        }
        self._srvUrl = canon(url);
        self.update(html, url);
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url;
      }).then(function () {
        if (self.ctrl === ctrl) { self.ctrl = null; self._pending = null; self.busy(false); }
      });
    }

    update(html, url) {
      var fresh = parse(html).querySelector('kj-collection');
      if (!fresh) throw new Error('kj-collection missing');
      var self = this;
      this.gen += 1;
      ['[data-kj-coll-count]', '[data-kj-coll-active]', '[data-kj-active-count]', '[data-kj-coll-results]'].forEach(function (sel) {
        var a = self.querySelector(sel), b = fresh.querySelector(sel);
        if (a) a.innerHTML = b ? b.innerHTML : '';
      });
      var ns = fresh.querySelector('[data-kj-sort-select]');
      if (ns && this.sortSelect) {
        this.sortSelect.innerHTML = ns.innerHTML;
        var sel = ns.querySelector('option[selected]');
        if (sel) this.sortSelect.value = sel.value;
        this.syncSortFace();
      }
      if (this.drawer) {
        var nd = fresh.querySelector('[data-kj-facets]');
        if (nd) this.updateDrawer(nd);
        this.fixLinks(this.drawer);
      }
      // the toolbar is not replaced: a quick row the first render could not build (no products then) is added once
      if (!this.quick && this.bar) {
        var nq = fresh.querySelector('[data-kj-quick]');
        var left = this.bar.querySelector('.kj-coll__bar-left');
        if (nq && left) {
          left.appendChild(document.importNode(nq, true));
          this.bar.classList.add('kj-coll__bar--quick');
          this.bindQuick();
        }
      }
      this.captureServer();
      this.fixLinks(this);
      this.dirty = true;
      this.afterRender('update', url);
      var status = this.querySelector('[data-kj-coll-status]');
      if (status) {
        var src = this.querySelector('[data-kj-coll-count]') || (this.drawer && this.drawer.querySelector('[data-kj-facets-count]'));
        status.textContent = src ? src.textContent.trim() : '';
      }
    }

    updateDrawer(nd) {
      var self = this;
      var active = document.activeElement;
      Array.prototype.forEach.call(nd.querySelectorAll('[data-kj-facet]'), function (ng) {
        var key = ng.getAttribute('data-kj-facet');
        var og = self.drawer.querySelector('[data-kj-facet="' + esc(key) + '"]');
        if (!og) return;
        var keep = self.keepGroups && ((active && og.contains(active)) || og === self.lastGroup);
        if (!keep) { og.parentNode.replaceChild(document.importNode(ng, true), og); return; }
        Array.prototype.forEach.call(ng.querySelectorAll('[data-kj-opt]'), function (ni) {
          var id = ni.getAttribute('data-kj-opt');
          var oi = og.querySelector('[data-kj-opt="' + esc(id) + '"]');
          if (oi) oi.disabled = ni.disabled && !oi.checked;
          var nc = ng.querySelector('[data-kj-opt-count="' + esc(id) + '"]');
          var oc = og.querySelector('[data-kj-opt-count="' + esc(id) + '"]');
          if (nc && oc) oc.textContent = nc.textContent;
        });
        if (og.hasAttribute('data-kj-ok') !== ng.hasAttribute('data-kj-ok') && !og.contains(active)) {
          og.hidden = ng.hidden;
          if (ng.hasAttribute('data-kj-ok')) og.setAttribute('data-kj-ok', ''); else og.removeAttribute('data-kj-ok');
        }
      });
      this.lastGroup = null;
      var a = this.drawer.querySelector('[data-kj-facets-count]'), b = nd.querySelector('[data-kj-facets-count]');
      if (a && b) a.textContent = b.textContent;
      var c1 = this.drawer.querySelector('[data-kj-facets-clear]'), c2 = nd.querySelector('[data-kj-facets-clear]');
      if (c1 && c2) { c1.hidden = c2.hasAttribute('hidden'); c1.setAttribute('href', clean(c2.getAttribute('href'))); }
    }

    busy(on) {
      this.classList.toggle('is-busy', on);
      this.setAttribute('aria-busy', on ? 'true' : 'false');
      var btn = this.drawer && this.drawer.querySelector('[data-kj-facets-apply]');
      if (btn) btn.classList.toggle('is-busy', on);
    }

    scrollToResults() {
      if (!this.bar) return;
      // scrolling up reveals the (compact) header, which the stuck toolbar sits under
      var y = this.bar.getBoundingClientRect().top + window.pageYOffset - this.headerOffset();
      if (window.pageYOffset > y + 4) window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' });
    }

    fixLinks(root) {
      Array.prototype.forEach.call(root.querySelectorAll('a[href*="section_id="]'), function (a) {
        a.setAttribute('href', clean(a.getAttribute('href')));
      });
    }

    afterRender(kind, url) {
      this.applySizes();
      this.bindMore();
      var results = this.querySelector('[data-kj-coll-results]');
      if (results && window.KJ && window.KJ.init) window.KJ.init(results);
      this.applyTheme(url || this._tfUrl || window.location.href, kind || 'update');
    }

    /* ---------- price buckets (native gte/lte) ---------- */
    applyBucket(btn) {
      var row = btn.closest('[data-kj-facet]');
      if (!row) return;
      var gte = row.querySelector('[data-kj-price="gte"]'), lte = row.querySelector('[data-kj-price="lte"]');
      if (!gte || !lte) return;
      var on = btn.getAttribute('aria-pressed') !== 'true';
      gte.value = on ? (btn.getAttribute('data-gte') || '') : '';
      lte.value = on ? (btn.getAttribute('data-lte') || '') : '';
      this.syncBuckets(row);
      this.lastGroup = row;
      this.dirty = true;
      this.apply(null, true);
    }

    syncBuckets(row) {
      if (!row) return;
      var gte = row.querySelector('[data-kj-price="gte"]'), lte = row.querySelector('[data-kj-price="lte"]');
      if (!gte || !lte) return;
      var g = num(gte.value), l = num(lte.value);
      each(row.querySelectorAll('[data-kj-price-bucket]'), function (b) {
        var on = (g !== null || l !== null) && num(b.getAttribute('data-gte')) === g && num(b.getAttribute('data-lte')) === l;
        b.setAttribute('aria-pressed', String(on));
      });
    }

    /* ---------- theme filters ---------- */
    initTheme() {
      this.bindQuick();
      var tpl = this.querySelector('template[data-kj-tf-icon]');
      this._xIcon = tpl && tpl.innerHTML.trim() ? tpl.innerHTML : X_ICON;
      this.remembered = store(RING_KEY) || '';
      this.captureServer();
      this._srvUrl = canon(this.buildUrl());
      this.applyTheme(window.location.href, 'init');
    }

    bindQuick() {
      this.quick = this.querySelector('[data-kj-quick]');
      if (!this.quick) return;
      var list = this.quick.querySelector('[data-kj-quick-list]');
      if (list) this.initFade(this.quick, list);
    }

    /* server-rendered texts, restored when no theme filter is active */
    captureServer() {
      var c = this.querySelector('[data-kj-coll-count]');
      this._srvCount = c ? c.innerHTML : null;
      var a = this.drawer && this.drawer.querySelector('[data-kj-facets-count]');
      this._srvApply = a ? a.textContent : null;
      var n = this.querySelector('[data-kj-active-count]');
      this._srvActive = n ? (parseInt(n.textContent.replace(/\D+/g, ''), 10) || 0) : 0;
    }

    tfRows() {
      return this.form ? Array.prototype.slice.call(this.form.querySelectorAll('[data-kj-tf-group]')) : [];
    }

    readTheme(url, keys) {
      var st = {}, u;
      try { u = new URL(url, window.location.href); } catch (e) { u = new URL(window.location.href); }
      keys.forEach(function (k) {
        var seen = {};
        st[k] = u.searchParams.getAll(TF + k).map(function (v) { return String(v).trim(); }).filter(function (v) {
          if (!v || seen[v]) return false;
          seen[v] = 1;
          return true;
        });
      });
      return st;
    }

    itemData(li, keys) {
      var d = li._kjF;
      if (!d) {
        d = li._kjF = {};
        var l = li.getAttribute('data-kj-f-l');
        if (l) { try { d._l = JSON.parse(l); } catch (e) { d._l = null; } }
      }
      keys.forEach(function (k) { if (!d[k]) d[k] = words(li.getAttribute('data-kj-f-' + k)); });
      return d;
    }

    tfLabel(key, token) {
      var row = this.form && this.form.querySelector('[data-kj-tf-group="' + esc(key) + '"]');
      var inp = row && row.querySelector('[data-kj-tf][value="' + esc(token) + '"]');
      var txt = inp && inp.parentNode.querySelector('[data-kj-tf-txt]');
      if (txt && txt.textContent.trim()) return txt.textContent.trim();
      return (this._tfLabels && this._tfLabels[token]) || token;
    }

    /* the drawer input for a value; created (sorted) when a later page or the URL brings a new value */
    ensureOption(row, key, token) {
      var list = row.querySelector('[data-kj-tf-list]');
      if (!list) return null;
      var found = null;
      each(list.querySelectorAll('[data-kj-tf]'), function (i) { if (!found && i.value === token) found = i; });
      if (found) return found;
      var label = (this._tfLabels && this._tfLabels[token]) || token;
      var id = (row.getAttribute('data-kj-tf-id') || 'kj-tf-' + key) + '-x' + (++uid);
      var li = document.createElement('li');
      li.setAttribute('data-kj-tf-li', token);
      var inp = document.createElement('input');
      inp.className = 'kj-tf__input kj-visually-hidden';
      inp.type = 'checkbox';
      inp.name = TF + key;
      inp.id = id;
      inp.value = token;
      inp.setAttribute('data-kj-tf', key);
      var lab = document.createElement('label');
      lab.className = 'kj-chip kj-tf__chip';
      lab.htmlFor = id;
      var tx = document.createElement('span');
      tx.className = 'kj-tf__txt';
      tx.setAttribute('data-kj-tf-txt', '');
      tx.textContent = label;
      var n = document.createElement('span');
      n.className = 'kj-tf__n';
      n.setAttribute('data-kj-tf-n', '');
      lab.appendChild(tx);
      lab.appendChild(n);
      li.appendChild(inp);
      li.appendChild(lab);
      var cmp = cmpFor(key), ref = null, me = { t: token, l: label };
      var lis = list.querySelectorAll('[data-kj-tf-li]');
      for (var j = 0; j < lis.length; j++) {
        var o = lis[j].querySelector('[data-kj-tf]'), ol = lis[j].querySelector('[data-kj-tf-txt]');
        if (o && cmp(me, { t: o.value, l: ol ? ol.textContent : o.value }) < 0) { ref = lis[j]; break; }
      }
      list.insertBefore(li, ref);
      return inp;
    }

    onThemeInput(inp) {
      var key = inp.getAttribute('data-kj-tf');
      if (inp.checked) this.noteTheme(key, inp.value);
      this.dirty = true;
      this._announce = true;
      this.apply(null, true);
    }

    noteTheme(key, token) {
      this._tfLast = { key: key, token: token };
      if (key === 'talla') { store(RING_KEY, token); this.remembered = token; }
    }

    /* toggle one value (pills, quick chips, «Quitar «x»») and apply */
    setTheme(key, token, on) {
      var row = this.form && this.form.querySelector('[data-kj-tf-group="' + esc(key) + '"]');
      var inp = row ? this.ensureOption(row, key, token) : null;
      if (!inp) return;
      inp.disabled = false;
      inp.checked = !!on;
      if (on) this.noteTheme(key, token);
      this._announce = true;
      this.apply(null, false);
    }

    clearTheme() {
      if (!this.form) return;
      each(this.form.querySelectorAll('[data-kj-tf]'), function (i) { i.checked = false; });
      this._announce = true;
      this.apply(null, false);
    }

    focusAfterPill() {
      var self = this;
      requestAnimationFrame(function () {
        var t = self.querySelector('[data-kj-coll-active] a') || (self.bar && self.bar.querySelector('[data-kj-filter-btn]:not([hidden])'));
        if (t) { try { t.focus(); } catch (e) { /* ignore */ } }
      });
    }

    /* keyboard «Quitar «x»»: the empty state (and its button) usually hides → focus the first product shown */
    focusAfterUndo(btn) {
      var self = this;
      requestAnimationFrame(function () {
        var empty = self.querySelector('[data-kj-tf-empty]');
        if (empty && !empty.hidden && !btn.hidden && empty.contains(btn)) return;
        var link = self.querySelector('[data-kj-coll-grid] > [data-kj-coll-item]:not([hidden]) a[href]');
        if (link) { try { link.focus(); } catch (e) { /* ignore */ } } else self.focusAfterPill();
      });
    }

    applyTheme(url, kind) {
      var self = this;
      url = url || window.location.href;
      this._tfUrl = url;
      var ds = this.dataset;
      var rows = this.tfRows();
      var keys = rows.map(function (r) { return r.getAttribute('data-kj-tf-group'); });
      var st = this.readTheme(url, keys);
      var nTheme = 0;
      keys.forEach(function (k) { nTheme += st[k].length; });
      var active = nTheme > 0;
      this.classList.toggle('is-tf-active', active);

      var grid = this.querySelector('[data-kj-coll-grid]');
      var items = grid ? Array.prototype.filter.call(grid.children, function (n) { return n.hasAttribute('data-kj-coll-item'); }) : [];
      var data = items.map(function (li) { return self.itemData(li, keys); });

      // labels of every loaded value (for values the server did not render in the drawer)
      var labels = this._tfLabels || (this._tfLabels = {});
      data.forEach(function (d) {
        if (!d._l) return;
        Object.keys(d._l).forEach(function (t) { if (!labels[t]) labels[t] = String(d._l[t]); });
      });

      // drawer inputs follow the URL (server links / history can change it)
      rows.forEach(function (row, i) {
        var k = keys[i], present = {};
        data.forEach(function (d) { d[k].forEach(function (t) { present[t] = 1; }); });
        st[k].forEach(function (t) { present[t] = 1; });
        Object.keys(present).forEach(function (t) { self.ensureOption(row, k, t); });
        each(row.querySelectorAll('[data-kj-tf]'), function (inp) { inp.checked = st[k].indexOf(inp.value) > -1; });
      });

      // items
      var visible = 0;
      items.forEach(function (li, i) {
        var ok = !active || matches(data[i], st, keys, null);
        if (li.hidden !== !ok) li.hidden = !ok;
        if (ok) visible += 1;
      });

      // facet counts: items matching every OTHER active group (base = how many items those are)
      var counts = {}, bases = {};
      keys.forEach(function (k) {
        var c = counts[k] = {};
        bases[k] = 0;
        data.forEach(function (d) {
          if (active && !matches(d, st, keys, k)) return;
          bases[k] += 1;
          d[k].forEach(function (t) { c[t] = (c[t] || 0) + 1; });
        });
      });
      // the focused control never disappears or gets disabled under the keyboard (re-evaluated on the next apply)
      var focused = document.activeElement;
      rows.forEach(function (row, i) {
        var k = keys[i], c = counts[k], pos = 0, narrows = false;
        each(row.querySelectorAll('[data-kj-tf-li]'), function (li) {
          var inp = li.querySelector('[data-kj-tf]');
          if (!inp) return;
          var n = c[inp.value] || 0;
          if (n > 0) pos += 1;
          if (n > 0 && n < bases[k]) narrows = true;
          inp.disabled = n === 0 && !inp.checked && inp !== focused;
          var nEl = li.querySelector('[data-kj-tf-n]');
          if (nEl) nEl.textContent = String(n);
          li.classList.toggle('is-remembered', k === 'talla' && !!self.remembered && inp.value === self.remembered && !inp.checked);
        });
        // ≥ 2 values that would actually narrow the list, or a value is active
        var show = (pos >= 2 && narrows) || st[k].length > 0 || (!!focused && row.contains(focused));
        if (row.hidden === show) row.hidden = !show;
      });

      // quick chips
      if (this.quick) {
        var qk = this.quick.getAttribute('data-kj-quick');
        if (keys.indexOf(qk) < 0) {
          this.quick.hidden = true;
        } else {
          var qc = counts[qk] || {}, qs = st[qk] || [];
          each(this.quick.querySelectorAll('[data-kj-quick-chip]'), function (b) {
            var t = b.getAttribute('data-kj-tf-token');
            var on = qs.indexOf(t) > -1;
            b.setAttribute('aria-pressed', String(on));
            b.disabled = !on && !qc[t] && b !== focused;
            b.classList.toggle('is-remembered', qk === 'talla' && !!self.remembered && t === self.remembered && !on);
          });
        }
      }

      // editorial tiles have no meaning in a filtered grid
      if (grid) {
        each(grid.querySelectorAll('[data-kj-coll-promo]'), function (p) {
          if (active) {
            if (!p.hidden) { p.hidden = true; p.setAttribute('data-kj-tf-hid', ''); }
          } else if (p.hasAttribute('data-kj-tf-hid')) {
            p.hidden = false;
            p.removeAttribute('data-kj-tf-hid');
          }
        });
      }

      // counts (header, drawer button, «Filtrar (n)»)
      var countEl = this.querySelector('[data-kj-coll-count]');
      if (countEl) {
        if (active) countEl.textContent = fill(visible === 1 ? ds.kjCountOne : ds.kjCountMany, visible);
        else if (this._srvCount != null && countEl.innerHTML !== this._srvCount) countEl.innerHTML = this._srvCount;
      }
      var applyEl = this.drawer && this.drawer.querySelector('[data-kj-facets-count]');
      if (applyEl) {
        if (active) applyEl.textContent = visible === 0 ? (ds.kjApplyNone || '0') : visible === 1 ? (ds.kjApplyOne || '1') : fill(ds.kjApply, visible);
        else if (this._srvApply != null) applyEl.textContent = this._srvApply;
      }
      var nAll = (this._srvActive || 0) + nTheme;
      var ac = this.querySelector('[data-kj-active-count]');
      if (ac) ac.textContent = nAll > 0 ? '(' + nAll + ')' : '';
      var clr = this.drawer && this.drawer.querySelector('[data-kj-facets-clear]');
      if (clr) clr.hidden = nAll === 0;

      this.renderPills(keys, st);

      // a filtered view must see every product: the remaining pages load first (max 10, each one filtered on
      // arrival); «no results» only once nothing is left to load
      var needAll = active && this._tfAllGen !== this.gen && !!this.querySelector('[data-kj-load-more]');
      var waiting = needAll || !!this._loadingAll;

      // client-side empty state («Quitar «último filtro»» + «Borrar todo»)
      var empty = this.querySelector('[data-kj-tf-empty]');
      if (empty) {
        var none = active && !!grid && visible === 0 && !waiting;
        empty.hidden = !none;
        this._tfUndo = null;
        if (none) {
          var last = null;
          if (this._tfLast && st[this._tfLast.key] && st[this._tfLast.key].indexOf(this._tfLast.token) > -1) last = this._tfLast;
          if (!last) {
            var tp = themePairs(url);
            for (var i = tp.length - 1; i >= 0; i--) {
              var k = tp[i][0].slice(TF.length);
              if (st[k] && st[k].indexOf(tp[i][1]) > -1) { last = { key: k, token: tp[i][1] }; break; }
            }
          }
          this._tfUndo = last;
          var ub = empty.querySelector('[data-kj-tf-undo]');
          if (ub) {
            ub.hidden = !last;
            if (last) ub.textContent = String(ds.kjStrUndo || 'Quitar «[filter]»').replace('[filter]', this.tfLabel(last.key, last.token));
          }
        }
      }

      // «Filtrar»: only when a native or theme group qualifies (or something is active)
      var fbtn = this.bar && this.bar.querySelector('[data-kj-filter-btn]');
      if (fbtn && this.drawer) {
        var q = this.drawer.querySelector('[data-kj-facet]:not([data-kj-facet="sort"]):not([hidden]), [data-kj-tf-group]:not([hidden])');
        fbtn.hidden = !(q || nAll > 0);
      }

      if (needAll && !this._loadingAll) this.loadAll();
      if (!this._loadingAll) this.classList.remove('kj-tf-pending');

      // the result count is announced once every page is in (not page 1's partial count)
      if (this._announce && !waiting) {
        this._announce = false;
        var status = this.querySelector('[data-kj-coll-status]');
        var src = countEl || applyEl;
        if (status && src) status.textContent = src.textContent.trim();
      }
      try {
        document.dispatchEvent(new CustomEvent('kj:collection:render', { detail: { kind: kind || 'theme', el: this, active: active, visible: visible } }));
      } catch (e) { /* ignore */ }
    }

    renderPills(keys, st) {
      var self = this;
      var wrap = this.querySelector('[data-kj-coll-active]');
      if (!wrap) return;
      each(wrap.querySelectorAll('[data-kj-tf-pill]'), function (n) { n.parentNode.removeChild(n); });
      var pills = [];
      keys.forEach(function (k) { st[k].forEach(function (t) { pills.push({ key: k, token: t }); }); });
      var own = wrap.querySelector('[data-kj-tf-list]');
      if (!pills.length) {
        if (own) own.parentNode.removeChild(own);
        return;
      }
      var ds = this.dataset;
      var list = wrap.querySelector('.kj-coll__active-list');
      if (!list) {
        // the server rendered no native pills: build the list + a «Borrar todo» that clears the theme filters
        list = document.createElement('ul');
        list.className = 'kj-coll__active-list';
        list.setAttribute('role', 'list');
        list.setAttribute('data-kj-tf-list', '');
        var cli = document.createElement('li');
        var ca = document.createElement('a');
        ca.className = 'kj-coll__clear';
        ca.setAttribute('data-kj-tf-clear', '');
        ca.href = stripTheme(this._tfUrl || window.location.href);
        ca.textContent = ds.kjStrClear || 'Borrar todo';
        cli.appendChild(ca);
        list.appendChild(cli);
        wrap.textContent = '';
        wrap.appendChild(list);
      }
      var clear = list.querySelector('.kj-coll__clear');
      var before = clear ? clear.closest('li') : null;
      pills.forEach(function (p) {
        var li = document.createElement('li');
        li.setAttribute('data-kj-tf-pill', '');
        var a = document.createElement('a');
        a.className = 'kj-coll__pill';
        a.href = self.urlWithout(p.key, p.token);
        a.setAttribute('data-kj-tf-remove', p.key + ':' + p.token);
        var sr = document.createElement('span');
        sr.className = 'kj-visually-hidden';
        sr.textContent = (ds.kjStrRemove || 'Quitar filtro') + ': ';
        a.appendChild(sr);
        a.appendChild(document.createTextNode(self.tfLabel(p.key, p.token)));
        var x = document.createElement('span');
        x.className = 'kj-coll__pill-x';
        x.setAttribute('aria-hidden', 'true');
        x.innerHTML = self._xIcon || X_ICON;
        a.appendChild(x);
        li.appendChild(a);
        list.insertBefore(li, before);
      });
    }

    urlWithout(key, token) {
      try {
        var u = new URL(this._tfUrl || window.location.href, window.location.href);
        var name = TF + key;
        var keep = u.searchParams.getAll(name).filter(function (v) { return v !== token; });
        u.searchParams.delete(name);
        keep.forEach(function (v) { u.searchParams.append(name, v); });
        return clean(u.pathname + u.search);
      } catch (e) { return window.location.pathname; }
    }

    /* load every remaining page (theme filters need the whole listing), filtering each page as it arrives */
    loadAll() {
      if (this._loadingAll) return this._loadingAll;
      var self = this, gen = this.gen, n = 0;
      var wait = this.loading || Promise.resolve();
      var step = function () {
        if (self.gen !== gen) return null;
        var btn = self.querySelector('[data-kj-load-more]');
        if (!btn || n >= 10) return null;
        n += 1;
        return self.fetchMore(btn, gen).then(function () {
          // _loadingAll is set: this apply neither starts another loadAll nor lifts kj-tf-pending
          if (self.gen === gen) self.applyTheme(self._tfUrl, 'more');
        }).then(step);
      };
      this.classList.add('is-tf-loading');
      var p = wait.catch(function () { /* ignore */ }).then(step).catch(function () {
        each(self.querySelectorAll('[data-kj-load-more]'), function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
      }).then(function () {
        self._loadingAll = null;
        if (self.loading === p) self.loading = null;
        self._tfAllGen = gen;
        self.classList.remove('is-tf-loading');
        // same listing: bind the new items and re-apply; a re-render happened meanwhile: re-evaluate the new one
        if (self.gen === gen) self.afterRender('more', self._tfUrl);
        else self.applyTheme(self._tfUrl, 'update');
      });
      this._loadingAll = p;
      this.loading = p;
      return p;
    }

    /* ---------- density ---------- */
    setDensity(d, save) {
      if (d !== 'lo' && d !== 'hi') d = 'hi';
      this.setAttribute('data-density', d);
      Array.prototype.forEach.call(this.querySelectorAll('[data-kj-density]'), function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-kj-density') === d));
      });
      if (save) store(KEY, d);
      this.applySizes();
    }

    applySizes() {
      var sizes = this.getAttribute('data-density') === 'lo' ? this.dataset.sizesLo : this.dataset.sizesHi;
      if (!sizes) return;
      Array.prototype.forEach.call(this.querySelectorAll('[data-kj-coll-grid] .kj-card__img'), function (img) {
        if (img.getAttribute('sizes') !== sizes) img.setAttribute('sizes', sizes);
      });
    }

    /* ---------- load more ---------- */
    bindMore() {
      var btn = this.querySelector('[data-kj-load-more]');
      if (this.io) { this.io.disconnect(); this.io = null; }
      if (!btn || this.dataset.load !== 'infinite' || !('IntersectionObserver' in window)) return;
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) self.loadMore(btn, false);
      }, { rootMargin: '0px 0px 700px 0px' });
      this.io.observe(btn);
    }

    /* fetch the next page and append its items; resolves to the first new item (null when discarded) */
    fetchMore(btn, gen) {
      var self = this;
      var url = clean(btn.getAttribute('href'));
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      return fetch(withSection(stripTheme(url), this.sid), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          // a filter / sort re-render replaced the grid meanwhile: these items belong to another listing
          if (self.gen !== gen) return null;
          var fresh = parse(html).querySelector('kj-collection');
          if (!fresh) throw new Error('kj-collection missing');
          var grid = self.querySelector('[data-kj-coll-grid]');
          var first = null;
          // theme filters on: new items arrive hidden; the next applyTheme reveals the matching ones
          var tfOn = self.classList.contains('is-tf-active');
          if (grid) {
            Array.prototype.forEach.call(fresh.querySelectorAll('[data-kj-coll-grid] > [data-kj-coll-item]'), function (it, i) {
              var node = document.importNode(it, true);
              if (tfOn) node.hidden = true;
              node.classList.add('is-new');
              node.style.animationDelay = Math.min(i, 8) * 45 + 'ms';
              grid.appendChild(node);
              if (!first) first = node;
            });
            if (first) grid.hidden = false;
          }
          var others = self.querySelector('[data-kj-coll-others]');
          var newOthers = fresh.querySelectorAll('[data-kj-coll-others] > li');
          if (others && newOthers.length) {
            Array.prototype.forEach.call(newOthers, function (li) { others.appendChild(document.importNode(li, true)); });
            var wrap = others.closest('[data-kj-coll-others-wrap]');
            if (wrap) wrap.hidden = false;
          }
          var oldMore = self.querySelector('[data-kj-coll-more]'), newMore = fresh.querySelector('[data-kj-coll-more]');
          if (oldMore && newMore) oldMore.parentNode.replaceChild(document.importNode(newMore, true), oldMore);
          self.fixLinks(self);
          return first;
        });
    }

    loadMore(btn, fromKeyboard) {
      if (this.loading) return;
      var self = this, gen = this.gen;
      var url = clean(btn.getAttribute('href'));
      var p = this.loading = this.fetchMore(btn, gen)
        .then(function (first) {
          if (self.gen !== gen) return;
          self.afterRender('more');
          if (fromKeyboard && first) {
            // the first new item may be filtered out by a theme filter: focus the first one shown
            var it = first;
            while (it && (it.hidden || !it.hasAttribute('data-kj-coll-item'))) it = it.nextElementSibling;
            var link = it && it.querySelector('a[href]');
            if (link) link.focus();
          }
        })
        .catch(function () { window.location.href = url; })
        .then(function () { if (self.loading === p) self.loading = null; });
    }

    /* ---------- description clamp (header or «Sobre la colección») ---------- */
    initDesc() {
      var self = this;
      each(this.querySelectorAll('[data-kj-coll-desc]'), function (wrap) {
        var text = wrap.querySelector('[data-kj-desc-body]') || wrap.querySelector('.kj-coll__desc-text');
        var btn = wrap.querySelector('[data-kj-desc-more]');
        if (!text || !btn) return;
        var check = function () { if (!wrap.classList.contains('is-open')) btn.hidden = !(text.scrollHeight > text.clientHeight + 2); };
        check();
        if (!self._descFonts && document.fonts && document.fonts.ready) {
          self._descFonts = true;
          document.fonts.ready.then(function () { self.initDesc(); });
        }
      });
    }

    /* ---------- active sort next to "Ordenar" ---------- */
    syncSortFace() {
      var sel = this.sortSelect;
      if (!sel) return;
      var wrap = sel.closest('[data-kj-sort]');
      var cur = wrap && wrap.querySelector('[data-kj-sort-cur]');
      if (!cur) return;
      var opt = sel.options[sel.selectedIndex];
      var def = this.dataset.defaultSort;
      var on = !!(opt && def && opt.value !== def);
      cur.textContent = on ? (opt.getAttribute('data-short') || opt.textContent || '').trim() : '';
      wrap.classList.toggle('is-sorted', on);
    }

    /* ---------- chip rows: current chip in view + overflow fades ---------- */
    initChips() {
      var nav = this.querySelector('[data-kj-chips]');
      var list = nav && nav.querySelector('[data-kj-chips-list]');
      if (!list) return;
      var cur = list.querySelector('[data-kj-chip-current]');
      if (cur && list.scrollWidth > list.clientWidth + 1) {
        var lr = list.getBoundingClientRect(), cr = cur.getBoundingClientRect();
        var pad = parseFloat(window.getComputedStyle(list).paddingLeft) || 0;
        if (cr.right > lr.right - 48 || cr.left < lr.left + pad) {
          list.scrollLeft = Math.max(0, list.scrollLeft + cr.left - lr.left - pad - 28);
        }
      }
      this.initFade(nav, list);
    }

    initFade(nav, list) {
      var sync = function () {
        var max = list.scrollWidth - list.clientWidth;
        nav.classList.toggle('is-scrolled', list.scrollLeft > 2);
        nav.classList.toggle('at-end', max <= 2 || list.scrollLeft >= max - 2);
      };
      list.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      this._resizers.push(sync);
      sync();
    }

    /* ---------- sticky toolbar under the floating header ----------
       Position comes from CSS (top: var(--kj-header-visible)); JS only flags the stuck state for the shadow. */
    headerOffset() {
      var v = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--kj-header-visible')) || 0;
      if (v > 0 && v < window.innerHeight * 0.4) this._hdrSeen = v;
      return this._hdrSeen || v || 0;
    }

    initSticky() {
      if (!this.bar) return;
      var self = this;
      this._onScroll = function () {
        if (self._raf) return;
        self._raf = requestAnimationFrame(function () { self._raf = 0; self.positionBar(); });
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._onScroll();
    }

    positionBar() {
      if (!this.bar || !this.isConnected) return;
      var top = parseFloat(window.getComputedStyle(this.bar).top) || 0;
      if (top > 0 && document.documentElement.classList.contains('kj-header--compact')) this._hdrSeen = top;
      var stuck = window.pageYOffset > 2 && this.bar.getBoundingClientRect().top <= top + 1;
      if (stuck !== this._stuck) {
        this._stuck = stuck;
        this.bar.classList.toggle('is-stuck', stuck);
      }
    }
  }

  customElements.define('kj-collection', KJCollection);
})();
